// Debug logging for the local search engine (MiniSearch providers).
//
// These payloads are large (full hit lists with per-index scores) and exist to
// support the local-vs-Algolia quality evaluation, so they must never reach a
// production console. CRA does not strip console calls at build time, hence the
// explicit env gate — same pattern as src/api.js and src/actions/mediaUpload.js.
export function searchDebugLog(...args) {
  if (process.env.REACT_APP_ENV === 'production') return
  // eslint-disable-next-line no-console
  console.log(...args)
}
